export default function TrustBar() {
  const items = [
    { icon: 'ri-award-line', text: '40+ Years in Practice' },
    { icon: 'ri-stethoscope-line', text: 'Board-Certified MD' },
    { icon: 'ri-flask-line', text: 'IV & Chelation Therapy' },
    { icon: 'ri-brain-line', text: 'Orthomolecular Psychiatry' },
    { icon: 'ri-user-heart-line', text: 'Thousands of Patients Helped' },
    { icon: 'ri-map-pin-line', text: 'Hackensack, NJ — Bergen County' },
    { icon: 'ri-article-line', text: 'Published Medical Author' },
  ];

  return (
    <section style={{ background: '#0a3d35' }} className="py-4 border-b border-teal-800">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
          {items.map((item, i) => (
            <div key={i} className="flex items-center gap-2">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`${item.icon} text-base`} style={{ color: '#f59e0b' }}></i>
              </div>
              <span className="text-teal-100 text-xs font-medium tracking-wide whitespace-nowrap">{item.text}</span>
              {i < items.length - 1 && (
                <span className="hidden lg:block w-px h-3 bg-teal-700 ml-3"></span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
